import React, { useContext, useEffect, useState, useCallback } from 'react';
import { LangContext } from '../../../common/decorators/Language';
import { A, svgSprite } from '../../../hybrid/wrappers';
import T, { t } from '../../../common/components/T';
import SingleNews from '../components/SingleNews/SingleNews';
import { getData } from '../../../common/utils/router';
import NewsCategoriesWrapper from '../components/categories/NewsCategoriesWrapper/NewsCategoriesWrapper';
import UpBtnNews from '../components/UpBtnNews/UpBtnNews';
import css from './News.module.scss';
import classnames from 'classnames';
import { useRouteAnimation } from '../../../common/utils/utils';

const NewsComponent = ({ news, categories, newsSettings }) => {
    const { translation } = useContext(LangContext) || {};
    const [allNews, setAllNews] = useState(news?.data ? news.data : []);
    const [query, setQuery] = useState(null);
    console.log(setQuery);
    // const selectPageItemsArr = [
    //     {
    //         value: 0,
    //         label: t('newsselectPageItemsArr1', 'Сначала новые', '/news', translation)
    //     },
    //     {
    //         value: 1,
    //         label: t('newsselectPageItemsArr2', 'Сначала старые', '/news', translation)
    //     }
    // ];
    // const selectPageItems = useRef(selectPageItemsArr);
    const [currE, setCurrE] = useState(0);
    useEffect(() => {
        (async () => {
            setAllNews(news?.data ? news.data : []);
        })();
    }, [news]);
    const [sorter, setSorter] = useState(0);
    const [currPage, setCurrPage] = useState(1);
    const [isShowMore, setIsShowMore] = useState(news?.meta?.current_page < news?.meta?.last_page);
    const changeTableItemsLength = useCallback(
        async (e) => {
            setCurrE(e.value);
            setCurrPage(1);
            const url = newsSettings?.id
                ? `/api/v1/news?page[size]=${newsSettings.size}&page[number]=${1}&filter[title]=${
                      query === null ? '' : encodeURI(query)
                  }&filter[categories]=${newsSettings.id}${e.value === 0 ? '' : '&sort=created_at'}`
                : `/api/v1/news?page[size]=${newsSettings.size}&page[number]=${1}&filter[title]=${
                      query === null ? '' : encodeURI(query)
                  }${e.value === 0 ? '' : '&sort=created_at'}`;
            const newNews = await getData(url);
            setSorter(e.value);
            if (newNews?.data?.length > 0) {
                setAllNews(() => newNews.data);
            } else {
                setAllNews([]);
            }
            if (newNews?.meta?.current_page < newNews?.meta?.last_page) {
                setIsShowMore(true);
            } else {
                setIsShowMore(false);
            }
        },
        [newsSettings, query]
    );
    // const selectPageConfig = useMemo(
    //     () => ({
    //         className: 'newsFilterSelect',
    //         controlClassName: 'newsFilterSelect-dropdown-control',
    //         arrowClassName: 'newsFilterSelect-dropdown-arrow',
    //         options: selectPageItems.current,
    //         value: selectPageItems.current[0],
    //         onChange: changeTableItemsLength
    //     }),
    //     [changeTableItemsLength]
    // );
    // const [isShowed, setIsShowed] = useState(false);
    useEffect(() => {
        if (query !== null) {
            const timeOutId = setTimeout(() => {
                (async () => {
                    setCurrPage(1);
                    const url = newsSettings?.id
                        ? `/api/v1/news?page[size]=${newsSettings.size}&page[number]=${1}&filter[title]=${
                              query === null ? '' : encodeURI(query)
                          }&filter[categories]=${newsSettings.id}${currE === 0 ? '' : '&sort=created_at'}`
                        : `/api/v1/news?page[size]=${newsSettings.size}&page[number]=${1}&filter[title]=${
                              query === null ? '' : encodeURI(query)
                          }${currE === 0 ? '' : '&sort=created_at'}`;
                    const newNews = await getData(url);
                    if (newNews.data.length > 0) {
                        setAllNews(() => newNews.data);
                    } else {
                        setAllNews([]);
                    }
                    if (newNews?.meta?.current_page < newNews?.meta?.last_page) {
                        setIsShowMore(true);
                    } else {
                        setIsShowMore(false);
                    }
                })();
            }, 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [currE, newsSettings.id, newsSettings.size, query]);
    // const config = {
    //     attribute: 'product',
    //     type: 'input',
    //     search: {
    //         type: 'onInput',
    //         icon: 'search-thin',
    //         onClick: () => {
    //             setIsShowed((pre) => !pre);
    //         }
    //     },
    //     placeholder: t('newsSearchPhrase', 'Я ищу...', '/news', translation),
    //     handlers: {
    //         onChange: (e) => {
    //             setQuery(e);
    //         },
    //         onKeyPress: (e) => {
    //             if (e.target.value.length > 0) {
    //             }
    //         }
    //     },
    //     compStyle: {
    //         wrapper: {
    //             width: screenWidth ? '441px' : '100vw',
    //             className: uikit.mb0
    //         },
    //         input: css.filterFormInputSearchInput,
    //         inputFocus: css.filterFormInputSearchInput
    //     },
    //     value: ''
    // };
    useEffect(() => {
        (async () => {
            if (currPage > 1) {
                const url = newsSettings?.id
                    ? `/api/v1/news?page[size]=${newsSettings.size}&filter[categories]=${
                          newsSettings.id
                      }&page[number]=${currPage}${
                          query !== encodeURI('') && query !== null ? `&filter[title]=${encodeURI(query)}` : ''
                      }${currE === 0 ? '' : '&sort=created_at'}`
                    : `/api/v1/news?page[size]=${newsSettings.size}&page[number]=${currPage}${
                          query !== encodeURI('') && query !== null ? `&filter[title]=${encodeURI(query)}` : ''
                      }${currE === 0 ? '' : '&sort=created_at'}`;
                const newNews = await getData(url);
                if (newNews.data.length > 0) {
                    setAllNews((pre) => pre.concat(newNews.data));
                } else {
                }
                if (newNews?.meta?.current_page < newNews?.meta?.last_page) {
                    setIsShowMore(true);
                } else {
                    setIsShowMore(false);
                }
            }
        })();
    }, [currE, currPage, newsSettings.id, newsSettings.size, query]);

    const routerLoaderClass = useRouteAnimation();
    return (
        <div className={css.newsViewsWrap}>
            <UpBtnNews />
            <div className={css.newsNavigationWrap}>
                {/* {widthDimensions <= 768 && (
                    <div
                        style={{
                            transform: 'scale(-1,1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20px',
                            height: '20px'
                        }}
                    >
                        {svgSprite('angle-right', {
                            fill: 'var(--greyExtraDarkColor)',
                            width: '4px',
                            height: '8px'
                        })}
                    </div>
                )} */}
                <A href={`/`} className={classnames(css.newsNavigationLinks, css.newsNavigationLinksActive)}>
                    {t('mainPageTitle', 'Главная', 'all', translation)}
                </A>
                <div className={css.circleSeparator}></div>
                <A href={`/news`} className={classnames(css.newsNavigationLinks)}>
                    {t('mainPageTitle-news', 'Новости компании', '/news', translation)}
                </A>
            </div>
            <NewsCategoriesWrapper
                sorter={sorter}
                changeTableItemsLength={changeTableItemsLength}
                currentId={newsSettings?.seo_url}
                categories={categories}
            />
            {/* <div className={css.filterWrapper}>
                <div className={css.dropDown}>
                    <DropdownElement componentConfig={selectPageConfig} />
                </div>
                <div className={classnames(css.filterFormInputSearchDiv, isShowed && css.filterFormInputSearchDivShowed)}>
                    {isShowed ? (
                        <FormInput {...config} />
                    ) : (
                        <div onClick={() => setIsShowed((pre) => !pre)} className={css.wrapperSearch}>
                            {svgSprite('search-thin', {
                                className: css.formControlSearchIconSvg
                            })}
                        </div>
                    )}
                </div>
            </div> */}
            <div className={classnames(css.newsGrid, routerLoaderClass)}>
                {!allNews.length && (
                    <div style={{ margin: '0px' }} className={classnames(css.newsQuestion)}>
                        <T textName='newsPage' defaultStr='Пока нет новостей' page='/news' />
                    </div>
                )}
                {allNews.map((el, i) => (
                    <SingleNews key={`allNews_${i}`} news={el} />
                ))}
            </div>
            {isShowMore && (
                <div
                    onClick={() => {
                        setCurrPage((pre) => ++pre);
                    }}
                    className={css.showMoreStyles}
                >
                    {svgSprite('load', {
                        width: 28,
                        height: 28,
                        fill: 'var(--blueColor)'
                    })}
                    <div style={{ marginLeft: '17px' }}>
                        <T textName='showMore' defaultStr='Показать еще' page='/news' />
                    </div>
                </div>
            )}
        </div>
    );
};
export default NewsComponent;
